import React, { useState, useEffect } from "react";

import axios from "@app/lib/axios";

import ReactTooltip from "react-tooltip";

import * as Constant from "../../../Constant.js";

const AppInfoForm = ({ data, tagList, platformList, dataCallback }) => {
    const [appData, setAppData] = useState({ id: "", thumb_url: "", name: "", platforms: [], tags: [], charger_p: "", charger_d: "", deploy_url: "" });
    const [originPlatforms, setOriginPlatforms] = useState([]);
    useEffect(() => {
        if (data) {
            setAppData(data);
            setOriginPlatforms(JSON.parse(JSON.stringify(data.platforms)));
        } else {
            setAppData({ id: "", thumb_url: "", name: "", platforms: [], tags: [], charger_p: "", charger_d: "", deploy_url: "" });
        }
        return () => {};
    }, [data]);

    const textHandeler = (e) => {
        const { name, value } = e.target;
        const temp = { ...appData };

        temp[name] = value;
        setAppData(temp);
    };

    const checkboxHandeler = (e) => {
        const { name, value, checked } = e.target;
        const temp = { ...appData };
        let arr = temp[name];
        let val = !isNaN(value) ? Number(value) : value;
        if (checked) {
            if (!arr.includes(val)) arr.push(val);
        } else {
            if (arr.includes(val)) {
                arr = arr.filter((a) => a !== val);
            }
        }

        temp[name] = arr;

        setAppData(temp);
    };

    const radioHandeler = (e) => {
        const { name, value, checked } = e.target;
        const temp = { ...appData };
        let val = !isNaN(value) ? Number(value) : value;
        temp[name] = [val];

        setAppData(temp);
    };

    const fileHandeler = (e) => {
        const { files } = e.target;
        if (!files) return;

        const file = files[0];
        if (!file) return;

        const maxSize = 1 * 1024 * 1024;
        if (file.size > maxSize) {
            alert("파일은 최대 1MB까지 가능합니다.");
            return;
        }

        const temp = { ...appData };

        const reader = new FileReader();
        reader.onloadend = () => {
            temp.thumb_url = reader.result;
            setAppData(temp);
        };
        reader.readAsDataURL(file);
    };

    const submitData = () => {
        const temp = { ...appData };
        if (!temp.id || !temp.id.trim()) {
            alert("앱 ID는 필수 항목입니다.");
            return;
        }

        if (!temp.name || !temp.name.trim()) {
            alert("이름 필수 항목입니다.");
            return;
        }

        if (temp.charger_p) {
            const pArr = temp.charger_p.split(",").filter((p) => p.trim().length > 30);
            if (pArr && pArr.length > 0) {
                alert("사업 담당자 명이 너무 깁니다. 담당자를 , 로 구분하고, 각 담당자 명은 30자 이내로 작성해주세요.");
                return;
            }
        }

        if (temp.charger_d) {
            const dArr = temp.charger_d.split(",").filter((d) => d.trim().length > 30);
            if (dArr && dArr.length > 0) {
                alert("개발 담당자 명이 너무 깁니다. 담당자를 , 로 구분하고, 각 담당자 명은 30자 이내로 작성해주세요.");
                return;
            }
        }

        axios({
            method: temp.isUpdate ? "patch" : "post",
            url: Constant.API_DOMAIN + "/api/app_version/info/" + temp.id,
            data: temp,
        })
            .then((result) => {
                if (result.data.code != "200") {
                    alert(result.data.msg);
                } else {
                    alert("저장 되었습니다.");
                    // do Callback
                    dataCallback(temp.id);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    let thumbnail = (
        <div className="text-center p-5 border" style={{ fontSize: "95px" }}>
            <span className="fas fa-file-image" />
        </div>
    );

    if (appData && appData.thumb_url) {
        thumbnail = (
            <div className="user-avatar text-center d-block p-5 border">
                <img className="" src={appData.thumb_url} alt="LOGO" style={{ minWidth: "100px", maxWidth: "100%", height: "128px" }} />
            </div>
        );
    }

    return (
        <>
            <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 ">
                    <label htmlFor="thumb">썸네일</label>
                    <input type="file" className="form-control form-control-sm" id="thumb" name="thumb" accept="image/*" onChange={fileHandeler} />
                    {thumbnail}
                </div>
                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-2">
                            <label htmlFor="id">앱 ID</label>
                            <input type="text" className="form-control p-1" id="id" name="id" disabled={appData.isUpdate} value={appData.id} onChange={textHandeler} />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-2">
                            <label htmlFor="name">이름</label>
                            <input type="text" className="form-control p-1" id="name" name="name" value={appData.name} onChange={textHandeler} />
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                            <h4 className="text-muted mb-1">플랫폼</h4>
                            {platformList &&
                                platformList.map((p) => {
                                    return (
                                        <label className="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                className="custom-control-input"
                                                type="checkbox"
                                                value={p.id}
                                                name="platforms"
                                                checked={appData.platforms && appData.platforms.includes(p.id)}
                                                onChange={checkboxHandeler}
                                            />
                                            <span className="custom-control-label">{p.name}</span>
                                        </label>
                                    );
                                })}
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                            <h4 className="text-muted mb-1">서비스 타겟</h4>
                            {tagList &&
                                tagList.map((t) => {
                                    return (
                                        <label className="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                className="custom-control-input"
                                                type="radio"
                                                value={t.id}
                                                name="tags"
                                                checked={appData.tags && appData.tags.includes(t.id)}
                                                onChange={radioHandeler}
                                            />
                                            <span className="custom-control-label" data-tip data-for={`tooltip_${t.id}`} effect="solid">
                                                {t.name}
                                            </span>
                                            <ReactTooltip id={`tooltip_${t.id}`} type="dark">
                                                <span>{t.desc}</span>
                                            </ReactTooltip>
                                        </label>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <label htmlFor="charger_p">사업담당자</label>
                    <input type="text" className="form-control p-1" id="charger_p" name="charger_p" value={appData && appData.charger_p ? appData.charger_p : ""} onChange={textHandeler} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <label htmlFor="charger_d">개발담당자</label>
                    <input type="text" className="form-control p-1" id="charger_d" name="charger_d" value={appData && appData.charger_d ? appData.charger_d : ""} onChange={textHandeler} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <label htmlFor="deploy_url">QA-URL</label>
                    <input type="text" className="form-control p-1" id="deploy_url" name="deploy_url" value={appData && appData.deploy_url ? appData.deploy_url : ""} onChange={textHandeler} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <label htmlFor="desc">비고</label>
                    <textarea className="form-control p-1" id="desc" name="desc" rows={3} value={appData && appData.desc ? appData.desc : ""} onChange={textHandeler} />
                </div>
            </div>
            <hr />
            <div className="text-right mt-3">
                <button className="btn btn-primary" onClick={submitData}>
                    {appData.isUpdate ? "수정" : "등록"}
                </button>
            </div>
        </>
    );
};

export default AppInfoForm;
